export enum ManagedAccountStep {
  PortfolioSetup = "PortfolioSetup",
  FeeAnalysis = "FeeAnalysis",
  Summary = "Summary",
}
